module.exports = __webpack_public_path__ + "static/media/8977.1b76c807.jpg";